import React from "react";
import { motion, useReducedMotion } from "framer-motion";

// react-snap prerenders without scroll, so whileInView never fires and would
// bake opacity:0 into the static HTML. During prerender (or when the user
// prefers reduced motion) we render plain, fully-visible content; the fade/slide
// is only a progressive enhancement in normal browsers.
const isSnap = typeof navigator !== "undefined" && navigator.userAgent === "ReactSnap";

export const Reveal = ({ children, delay = 0, y = 24, className = "", ...rest }) => {
  const reduce = useReducedMotion();
  if (isSnap || reduce) return <div className={className} {...rest}>{children}</div>;
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
      {...rest}
    >
      {children}
    </motion.div>
  );
};

export const Eyebrow = ({ children, dark = false }) => (
  <span
    className={`inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] font-medium ${
      dark ? "text-[#8EA694]" : "text-[#5C7567]"
    }`}
  >
    <span className={`h-px w-8 ${dark ? "bg-[#8EA694]" : "bg-[#C47C5D]"}`} aria-hidden="true" />
    {children}
  </span>
);
